import { render, staticRenderFns } from "./tariffSelect.vue?vue&type=template&id=40057ccd&scoped=true"
import script from "./tariffSelect.vue?vue&type=script&lang=js"
export * from "./tariffSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40057ccd",
  null
  
)

export default component.exports